var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGridFilled = function SvgGridFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 10.3c.55 0 1-.45 1-1v-3h-3.64L12 1 5.64 6.3H2v3c0 .55.45 1 1 1s1-.45 1-1v-1h3v3H2v3c0 .55.45 1 1 1s1-.45 1-1v-1h3v2.84l-.86 5.16H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1h-2.15l-.85-5v-3h3v1c0 .55.45 1 1 1s1-.45 1-1v-3h-5v-3h3v1c0 .55.45 1 1 1m-6.01 3h-6v-2h6zM9 8.3v-2h6v2zm.01 8h6l.31 2H8.68z",
    clipRule: "evenodd"
  })));
};
export default SvgGridFilled;